import defaultLocale from './translations.json'

export const store = {

    state: {
      locale: defaultLocale,
      iso: "sv-SE"
    },
    
    setLocale(locale) {
      this.state.locale = locale
    },

    setIso(iso) {
        this.state.iso = iso
    }

}  